import { debounce } from 'lodash';
import { useState, useEffect } from 'react';

const useWindowSize = (debounceDelay = 200) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, debounceDelay);

    window.addEventListener('resize', handleResize);

    return () => {
      handleResize.cancel(); // Cancel any pending debounced calls
      window.removeEventListener('resize', handleResize);
    };
  }, [debounceDelay]);

  return windowSize;
};

export default useWindowSize;
